// extracted by mini-css-extract-plugin
export default {"likeSpan":"HeartLikes_likeSpan__UCtQo","altBG":"HeartLikes_altBG__Xqm5e"};